export const ButtonTypes = {
  PRIMARY: 'primary_button',
  SECONDARY: 'secondary_button',
  SECONDARY_ALT: 'secondary_alt_button',
  TEXT: 'text_button',
} as const;

export type ButtonType = (typeof ButtonTypes)[keyof typeof ButtonTypes];
